'use client';

import { Icon } from '@/general/Icons/Icon';
import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { Button } from '@/general/components/Button/Button';
import { plpFilterModalStore } from '@/stores/plpFilterModalStore';

/**
 * Trigger for the filters modal on PLP
 */
export const PlpFiltersTrigger: FC = () => {
  const { setOpen } = plpFilterModalStore(
    (state) => ({
      setOpen: state.setOpen,
    }),
    shallow,
  );

  return (
    <Button
      variant="secondary"
      size="small"
      onClick={() => setOpen(true)}
      endIcon={<Icon name="filter" />}
      data-testid={`MobileSearch-component-filterButton`}
    >
      Filters
    </Button>
  );
};
